import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { withTranslation } from "react-i18next";
import bgSliders from "../../helpers/bgSliders";
import DjzReturnPageDisplay from "./DjzReturnPage.styled";
import "./DjzReturnPage.scss";

const DJZ_API_BASE = "https://vas2.grand-hub.com/api/playIt/djezzy-dz-d";

const randomBg = bgSliders.getRandomBg();

function DjzReturnPage({ t }) {
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const runCheck = async () => {
      try {
        const urlSearch = window.location.search;
        const url = `${DJZ_API_BASE}/check${urlSearch}`;
        const res = await axios.get(url);
        const success =
          res.data.success === true || res.data.status === "success";
        if (success) {
          history.replace("/djz-success");
        } else {
          history.replace("/djz-fail");
        }
      } catch (error) {
        history.replace("/djz-fail");
      } finally {
        setLoading(false);
      }
    };

    runCheck();
  }, []);

  return (
    <DjzReturnPageDisplay className="" bgImg={randomBg}>
      <div className="return-page">
        {loading && (
          <div className="spinner-wrap">
            <div className="spinner" />
            <p>{t("loading")}</p>
          </div>
        )}
      </div>
    </DjzReturnPageDisplay>
  );
}

export default withTranslation()(DjzReturnPage);
